"use client";

import { motion } from "framer-motion";
import { useTranslation } from "../hooks/useTranslation";
import { useIsMobile } from "../hooks/useIsMobile";
import GlassCard from "./GlassCard";

export default function LessonsSection() {
	const { t } = useTranslation();
	const isMobile = useIsMobile();

	return (
		<section className="py-10 px-4">
			<div className="max-w-6xl mx-auto">
				{isMobile ? (
					<div className="text-center mb-8">
						<h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
							{t("lessons.title")}
						</h2>
						<p className="text-xl text-gray-600 max-w-3xl mx-auto">
							{t("lessons.subtitle")}
						</p>
					</div>
				) : (
					<motion.div
						initial={{ opacity: 0, y: 50 }}
						whileInView={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.8 }}
						viewport={{ once: true }}
						className="text-center mb-16"
					>
						<h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
							{t("lessons.title")}
						</h2>
						<p className="text-xl text-gray-600 max-w-3xl mx-auto">
							{t("lessons.subtitle")}
						</p>
					</motion.div>
				)}

				<div className="max-w-4xl mx-auto">
					{isMobile ? (
						<GlassCard className="p-8">
							<div className="space-y-6">
								<p className="text-lg text-gray-700 leading-relaxed">
									{t("lessons.description")}
								</p>
								<p className="text-lg text-gray-700 leading-relaxed">
									{t("lessons.description2")}
								</p>
								<div className="pt-4">
									<h3 className="text-xl font-semibold text-gray-900 mb-4">
										{t("lessons.whatWeDo")}
									</h3>
									<div className="bg-gradient-to-r from-pink-500 to-violet-500 text-white p-4 rounded-lg">
										<p className="text-lg font-medium">
											{t("lessons.feature1")}
										</p>
									</div>
								</div>
							</div>
						</GlassCard>
					) : (
						<motion.div
							initial={{ opacity: 0, y: 50 }}
							whileInView={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.8, delay: 0.2 }}
							viewport={{ once: true }}
						>
							<GlassCard className="p-8">
								<div className="space-y-6">
									<motion.p
										initial={{ opacity: 0, x: -30 }}
										whileInView={{ opacity: 1, x: 0 }}
										transition={{ duration: 0.6, delay: 0.3 }}
										viewport={{ once: true }}
										className="text-lg text-gray-700 leading-relaxed"
									>
										{t("lessons.description")}
									</motion.p>
									<motion.p
										initial={{ opacity: 0, x: -30 }}
										whileInView={{ opacity: 1, x: 0 }}
										transition={{ duration: 0.6, delay: 0.4 }}
										viewport={{ once: true }}
										className="text-lg text-gray-700 leading-relaxed"
									>
										{t("lessons.description2")}
									</motion.p>
									<motion.div
										initial={{ opacity: 0, y: 30 }}
										whileInView={{ opacity: 1, y: 0 }}
										transition={{ duration: 0.6, delay: 0.5 }}
										viewport={{ once: true }}
										className="pt-4"
									>
										<h3 className="text-xl font-semibold text-gray-900 mb-4">
											{t("lessons.whatWeDo")}
										</h3>
										<motion.div
											initial={{ opacity: 0, scale: 0.95 }}
											whileInView={{ opacity: 1, scale: 1 }}
											transition={{ duration: 0.6, delay: 0.6 }}
											viewport={{ once: true }}
											className="bg-gradient-to-r from-pink-500 to-violet-500 text-white p-4 rounded-lg"
										>
											<p className="text-lg font-medium">
												{t("lessons.feature1")}
											</p>
										</motion.div>
									</motion.div>
								</div>
							</GlassCard>
						</motion.div>
					)}
				</div>
			</div>
		</section>
	);
}